/* @flow */

const isAndroid = () => /(android)/i.test(navigator.userAgent);

export default isAndroid;
